"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarComponent = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const clsx_1 = __importDefault(require("clsx"));
const Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
const SnackbarContent_1 = __importDefault(require("@material-ui/core/SnackbarContent"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
const snackbar_types_1 = require("./snackbar-types");
const snackbar_styles_1 = require("./snackbar-styles");
const timeout_hook_1 = require("../../utils/timeout-hook");
const variantIcon = {
    success: CheckCircle_1.default,
    warning: Warning_1.default,
    error: Error_1.default,
    info: Info_1.default,
    blank: undefined,
};
exports.SnackbarComponent = react_1.forwardRef(function SnackbarComponent({ timeout }, ref) {
    const classes = snackbar_styles_1.useStyles();
    const [triggerTimeout, cancelTimeout] = timeout_hook_1.useTimeout();
    const [snackbar, setSnackbar] = react_1.useState({
        message: '',
        variant: snackbar_types_1.SnackbarVariant.SUCCESS,
        open: false,
    });
    /**
     * Closes notification snackbar.
     */
    const hideSnackbar = event_callback_hook_1.useEventCallback(() => {
        setSnackbar((snackbar) => ({
            ...snackbar,
            open: false,
        }));
    });
    const showSnackbar = event_callback_hook_1.useEventCallback((message, variant, autohide) => {
        cancelTimeout();
        setSnackbar({ message, variant, open: true });
        let withTimeout = false;
        if (autohide === undefined) {
            withTimeout =
                timeout !== 0 &&
                    (variant === snackbar_types_1.SnackbarVariant.SUCCESS ||
                        variant === snackbar_types_1.SnackbarVariant.INFO);
        }
        if (autohide !== undefined) {
            withTimeout = timeout !== 0 && autohide;
        }
        if (withTimeout) {
            triggerTimeout(() => {
                hideSnackbar();
            }, timeout);
        }
    });
    react_1.useImperativeHandle(ref, () => ({ showSnackbar }), [showSnackbar]);
    const { variant, open, message } = snackbar;
    const Icon = variantIcon[variant];
    return (react_1.default.createElement(Snackbar_1.default, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, classes: { root: classes.snackbar }, open: open },
        react_1.default.createElement(SnackbarContent_1.default, { className: classes[variant], "aria-describedby": "client-snackbar", message: react_1.default.createElement("span", { id: "client-snackbar", className: clsx_1.default(classes.message, {
                    [classes.dark]: variant === snackbar_types_1.SnackbarVariant.BLANK,
                }) },
                Icon && (react_1.default.createElement(Icon, { className: clsx_1.default(classes.icon, classes.iconVariant) })),
                message), action: [
                react_1.default.createElement(IconButton_1.default, { key: "close", "aria-label": "Close", color: "inherit", onClick: hideSnackbar, size: "small", className: clsx_1.default({
                        [classes.dark]: variant === snackbar_types_1.SnackbarVariant.BLANK,
                    }) },
                    react_1.default.createElement(Close_1.default, { className: classes.icon })),
            ] })));
});
//# sourceMappingURL=snackbar-component.js.map